import { motion } from 'framer-motion'
import React, { useEffect, useState } from 'react'
import styled from 'styled-components'

import { deviceInfoStore, useSetRecoilState } from '@/store'

import { stepAnimate } from '..'
import contentwifiImg from '../images/content-wifi.gif'

const { resultState, netNumState, netLowestState, netHighestState } = deviceInfoStore

interface IProps {
  rtcEngine: any
  next: (stepActive: number, status?: boolean) => void
}

let theTimer: string | number | NodeJS.Timeout | undefined = undefined
export default ({ rtcEngine, next }: IProps) => {
  const setResultState = useSetRecoilState(resultState)
  const setNetNumState = useSetRecoilState(netNumState)
  const setNetLowestState = useSetRecoilState(netLowestState)
  const setNetHighestState = useSetRecoilState(netHighestState)
  const [startNetwork, setstartNetwork] = useState<boolean>(false)
  const [qualityTest, setqualityTest] = useState<number[]>([])
  const [delayedTest, setdelayedTest] = useState<number[]>([])
  const [timeEnd, setTimeEnd] = useState<boolean>(false)

  useEffect(() => {
    startNetworkHandle()
    theTimer = setTimeout(() => {
      setTimeEnd(true)
    }, 10000)

    return () => {
      console.log('------销毁-----')
      // .uplinkClient
      rtcEngine.leave()
      clearTimeout(theTimer)
    }
  }, [])

  // 停止流并计算网络质量
  useEffect(() => {
    if (timeEnd) {
      rtcEngine.off('localNetWorkGetStats', networkChange)
      // console.log('qualityTest', qualityTest)
      let qualityTestNum = 0

      const getQualityTest = getSum(qualityTest)
      qualityTestNum = parseInt(`${getQualityTest}`) || 0
      getQuality(qualityTestNum)
      setNumHandle(qualityTest)
    }
  }, [timeEnd, qualityTest])

  const handleNext = (status: any) => {
    clearTimeout(theTimer)
    next(4, status)
  }
  // 开始网络检测
  const startNetworkHandle = () => {
    // console.log('===========ddsf===,',this.rtcEngine.getConnectionState())
    rtcEngine.getNetWork()
    if (!startNetwork) {
      countlocalNetWork()
      setstartNetwork(true)
    }
  }
  // 获取网络的质量
  const countlocalNetWork = () => {
    rtcEngine.on('localNetWorkGetStats', networkChange)
  }
  const networkChange = (obj: { downlink: number; uplink: number }) => {
    // console.error('网络质量数据实时数据 :>> ', obj)
    setqualityTest((v) => [...v, obj.downlink])
    setdelayedTest((v) => [...v, obj.uplink])
  }
  // 通过最终的平均值来输出相应的检测质量结果
  const getQuality = (data: any) => {
    let result = ''
    switch (data) {
      case 1:
        result = '优'
        break
      case 2:
        result = '良好'
        break
      case 3:
        result = '一般'
        break
      case 4:
        result = '差'
        break
      case 5:
        result = '极差'
        break
      case 6:
        result = '断开'
        break
      case 0:
        result = '未知'
        break
    }
    setResultState(result)
    if (data <= 4 && data !== 0) {
      handleNext(true)
    } else {
      handleNext(false)
    }
  }
  // 计算数组里面的累加求和方法
  const getSum = (data: any) => {
    const sum = data.reduce((pre: number, cur: number) => pre + cur, 0)
    return sum / data.length
  }
  // 网络放到localStorage里面
  const setNumHandle = (value: any) => {
    if (value.length) {
      const netNum = value.length
      const netLowest = Math.min(...value.filter((e: any) => !isNaN(e)))
      const netHighest = Math.max(...value.filter((e: any) => !isNaN(e)))
      setNetNumState(netNum)
      setNetLowestState(netLowest)
      setNetHighestState(netHighest)
    }
  }

  return (
    <Container {...stepAnimate} className="alls-testing">
      <div className="base-img" />
      <div className="base-title">正在检测网络，预计10s左右完成</div>
    </Container>
  )
}

const Container = styled(motion.div)`
  .base-img {
    background-image: url('${contentwifiImg}');
  }
`
